import { Fragment } from 'react';

const Description = ({ data }: { data: string[] }) => {
  return Array.isArray(data) && data?.length > 0 ? (
    <section className="description-wrap">
      <ul className="description-list">
        {data?.map((text, i) => (
          <li key={`description-${i}`} className="description-item">
            <p dangerouslySetInnerHTML={{ __html: text }}></p>
          </li>
        ))}
      </ul>
    </section>
  ) : (
    <Fragment />
  );
};

export default Description;
